import {
	ServiceWorkerAPIRequestMessage,
	ServiceWorkerAPICommandName,
	StartRecordingApiRequestMessage, ResumeRecordingApiRequestMessage,
	StopRecordingApiRequestMessage,
	AddTabToRecordingApiRequestMessage,
	StartCrawlApiRequestMessage,
	SetCrawlStateApiRequestMessage,
	getCrawlStateApiRequestMessage,
} from '../../constants';
import type { ServiceWorkerAPI } from '../../ServiceWorker/api';
import { ProcessInfo } from '../../State/ProcessInfo';
import { SerializableError } from '../utils/SerializedException';


export const sendMessage = async (message: ServiceWorkerAPIRequestMessage) => {
	ProcessInfo.log(`service worker API Client ${message.messageType} calling chrome.runtime.sendMessage`, message);
	try {
		const response = await chrome.runtime.sendMessage(message);
		if (response != null && typeof response === 'object' && 'exception' in response) {
			ProcessInfo.errorLog(`Service Worker API  ${message.messageType} returned exception`, message, response.exception);
			throw SerializableError.from(response.exception, {api: `Service Worker API Client`, message});
		}
		return response;
	} catch (e) {
		ProcessInfo.errorLog(`service worker API client error sending message`, e);
		throw e;
	}
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PromisedReturnType<T extends (args: any) => any> = ReturnType<T> extends PromiseLike<infer U> ?
	Promise<U> : Promise<ReturnType<T>>;


export const ServiceWorkerAPIClient = {
	startCrawl: (argsObj: Omit<StartCrawlApiRequestMessage, "messageType">) => sendMessage({
		messageType: ServiceWorkerAPICommandName.startCrawl, ...argsObj
	} as const satisfies StartCrawlApiRequestMessage) as PromisedReturnType<typeof ServiceWorkerAPI.startCrawl>,

	setCrawlState: (argsObj: Omit<SetCrawlStateApiRequestMessage, "messageType">) => sendMessage({
		messageType: ServiceWorkerAPICommandName.setCrawlState, ...argsObj
	} as const satisfies SetCrawlStateApiRequestMessage) as PromisedReturnType<typeof ServiceWorkerAPI.setCrawlState>,

	getCrawlState: (argsObj: Omit<getCrawlStateApiRequestMessage, "messageType">) => sendMessage({
		messageType: ServiceWorkerAPICommandName.getCrawlState, ...argsObj
	} as const satisfies getCrawlStateApiRequestMessage) as PromisedReturnType<typeof ServiceWorkerAPI.getCrawlState>,

	startRecording: (argsObj: Omit<StartRecordingApiRequestMessage, "messageType">) => sendMessage({
		messageType: ServiceWorkerAPICommandName.startRecording, ...argsObj
	} as const satisfies StartRecordingApiRequestMessage) as PromisedReturnType<typeof ServiceWorkerAPI.startNewRecording>,

	addTabToRecording: (argsObj: Omit<AddTabToRecordingApiRequestMessage, "messageType">) => sendMessage({
		messageType: ServiceWorkerAPICommandName.addTabToRecording, ...argsObj
	} as const satisfies AddTabToRecordingApiRequestMessage) as PromisedReturnType<typeof ServiceWorkerAPI.addTabToRecording>,

	stopRecording: (argsObj: Omit<StopRecordingApiRequestMessage, "messageType">) => sendMessage({
		messageType: ServiceWorkerAPICommandName.stopRecording, ...argsObj
	} as const satisfies StopRecordingApiRequestMessage) as PromisedReturnType<typeof ServiceWorkerAPI.stopRecording>,

	resumeRecording: (argsObj: Omit<ResumeRecordingApiRequestMessage, "messageType">) => sendMessage({
		messageType: ServiceWorkerAPICommandName.resumeRecording, ...argsObj
	} as const satisfies ResumeRecordingApiRequestMessage) as PromisedReturnType<typeof ServiceWorkerAPI.resumeRecording>,

// 	addDevToolsOnRequestFinishedEvent: (argsObj: Omit<DevToolsAddOnRequestFinishedRequestMessage, "messageType">) => sendMessage({
// 		messageType: ServiceWorkerAPICommandName.addDevToolsOnRequestFinishedEvent, ...argsObj
// 	} as const satisfies DevToolsAddOnRequestFinishedRequestMessage) as PromisedReturnType<typeof ServiceWorkerAPI.addDevToolsOnRequestFinishedEvent>,
}
